/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { memo, useEffect, useState } from 'react'
import cx from 'classnames'
import Box from '@mui/material/Box'
import Slider from '@mui/material/Slider'

import CustomThumbComponent from '../CustomSliderThumb'

import useStyles from './styles'

const ThumbWithValue = (props) => <CustomThumbComponent hideLabel {...props} />

const CustomSliderV2 = ({ value = 0, hideLabel, min = -3, max = 6, onChange = () => {}, disabled }) => {
  const [innerValue, setInnerValue] = useState(value)
  const classes = useStyles()

  const handleChange = (e) => {
    setInnerValue(e)
    onChange(e)
  }

  useEffect(() => {
    setInnerValue(value)
  }, [value])

  return (
    <Box
      className={cx(classes.slider, {
        [classes.opacity]: !hideLabel,
        [classes.empty]: !innerValue && hideLabel,
        [classes.disabled]: disabled,
      })}
    >
      <Slider
        value={innerValue}
        min={min}
        max={max}
        slots={{ thumb: hideLabel ? ThumbWithValue : CustomThumbComponent }}
        onChange={(e) => handleChange(e.target.value)}
        aria-label="Default"
        valueLabelDisplay="off"
        disabled={disabled}
      />
    </Box>
  )
}

export default memo(CustomSliderV2)
